import "./polyfill";
import { App } from 'App';
import { AssetProvider } from 'provider/AssetProvider';
import { CoinhallTokenProvider } from 'provider/CoinhallTokensProvider';
import { PagePermissionProvider } from 'provider/PagePermissionProvider'
import { WalletProvider } from "provider/WalletProvider";

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
const container = document.getElementById('root');
const root = createRoot(container!);


root.render(
  <WalletProvider>
    <BrowserRouter>
      <CoinhallTokenProvider>
        <AssetProvider>
          <PagePermissionProvider>
            <App />
          </PagePermissionProvider>
        </AssetProvider>
      </CoinhallTokenProvider>
    </BrowserRouter>
  </WalletProvider>
)
